import React, { useEffect } from 'react';

const DisplayAd = ({ slot = '1234567890', format = 'auto', responsive = true }) => {
  useEffect(() => {
    // Load AdSense script if not already loaded
    if (window.adsbygoogle && window.adsbygoogle.loaded !== true) {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        console.error('AdSense error:', e);
      }
    }
  }, []);

  return (
    <div className="my-8 flex items-center justify-center min-h-[250px] bg-neutral-900/30 border border-neutral-800 rounded-lg overflow-hidden">
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-9776994437738262"
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={responsive ? 'true' : 'false'}
      />
    </div>
  );
};

export default DisplayAd;
